import { Text } from '@mantine/core'
import { formatCents } from '../utils'

// Claim-level reconciliation figures (contract: caseReconciliationSchema).
// "Insurance payment" is the EOB-entered expected figure; actual payment rows
// live in PaymentCards. The patient side (paid / left to collect) is shown by
// PatientResponsibilitySection, next to the actions that collect it.
export type CaseReconciliation = {
  providerChargeCents: number | null
  allowedCents: number | null
  patientRespCents: number | null
  adjustmentCents: number | null
  expectedInsuranceCents: number | null
  insurancePaidCents: number
  payerFeesCents: number | null
  patientPaidCents: number | null
  patientBalanceCents: number | null
}

function Row({ label, hint, cents }: { label: string; hint?: string; cents: number | null }) {
  return (
    <div className="flex items-baseline justify-between gap-2">
      <div className="flex items-baseline gap-2">
        <Text size="sm" fw={600} c="dimmed">
          {label}
        </Text>
        {hint ? (
          <Text size="xs" c="dimmed">
            {hint}
          </Text>
        ) : null}
      </div>
      <Text size="sm" c={cents === null ? 'dimmed' : 'dark'}>
        {cents === null ? '—' : formatCents(cents)}
      </Text>
    </div>
  )
}

export function ReconciliationSummary({ reconciliation }: { reconciliation: CaseReconciliation }) {
  return (
    <div className="flex flex-col gap-2">
      <Row label="Provider charge" hint="From claim" cents={reconciliation.providerChargeCents} />
      <Row label="Allowed" cents={reconciliation.allowedCents} />
      <Row label="Patient responsibility" cents={reconciliation.patientRespCents} />
      <Row label="Insurance payment" cents={reconciliation.expectedInsuranceCents} />
      {reconciliation.payerFeesCents !== null && reconciliation.payerFeesCents > 0 ? (
        <Row label="Payer fees" hint="Expected − received" cents={reconciliation.payerFeesCents} />
      ) : null}
      <Row label="Adjustment" hint="Auto-calculated" cents={reconciliation.adjustmentCents} />
    </div>
  )
}
